import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';
import theme from 'site-react/theme';

const letterStyle = css`
  width: 100%;
  height: 100%;
  display: block;
  text-align: center;
  font-family: ${theme.font.family.default};
  font-size: ${theme.font.size.sm};
  font-weight: ${theme.font.weight.medium};
  text-transform: uppercase;
  color: inherit;
`;

const wrapperStyle = css`
  background-color: ${theme.colors.white};
  border-radius: 50%;
  border: 2px solid ${theme.colors.neutral900};
  box-sizing: border-box;
  color: ${theme.colors.neutral900};
  display: inline-block;
  margin: 3px;
  overflow: hidden;
  position: relative;
  transition: background-color 0.3s ease;
  vertical-align: middle;
`;

const wrapperHoverStyle = css`
  &:hover {
    background-color: ${theme.colors.brandPrimary};
    border-color: ${theme.colors.brandPrimary};
    color: ${theme.colors.white};
    cursor: pointer;
  }
`;

const AccountIconLetter = ({ hover, letter, size }) => (
  <div
    className={cx(
      wrapperStyle,
      hover && wrapperHoverStyle,
      css`
        width: ${size + 4}px;
        height: ${size + 4}px;
      `,
    )}
    data-testid="account-icon"
    title="Your Account"
  >
    <span
      className={cx(
        letterStyle,
        css`
          line-height: ${size + 3}px;
        `,
      )}
    >
      {letter}
    </span>
  </div>
);

AccountIconLetter.propTypes = {
  /**
   * Should we show hover styles on this letter?
   */
  hover: PropTypes.bool.isRequired,

  /**
   * The letter to show
   */
  letter: PropTypes.string.isRequired,

  /**
   * Size of the letter/icon, in pixels
   */
  size: PropTypes.number.isRequired,
};

export default AccountIconLetter;
